/* eslint-disable */
// @ts-nocheck

/**
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as GoogleProtobufEmpty from '../../../google/protobuf/empty.pb';
import * as EdukitaPaulaBackendCommonFilter from '../common/filter.pb';
import * as EdukitaPaulaBackendGaragecacheEntities from '../garagecache/entities.pb';
import * as EdukitaPaulaBackendGaragecacheProfiles from '../garagecache/profiles.pb';
import * as EdukitaPaulaBackendV3Common from './common.pb';
import * as fm from '@generated/fetch.pb';

export enum BookRoadmapStatus {
    BOOK_ROADMAP_STATUS_UNSPECIFIED = 'BOOK_ROADMAP_STATUS_UNSPECIFIED',
    BOOK_ROADMAP_STATUS_NOT_STARTED = 'BOOK_ROADMAP_STATUS_NOT_STARTED',
    BOOK_ROADMAP_STATUS_IN_PROGRESS = 'BOOK_ROADMAP_STATUS_IN_PROGRESS',
    BOOK_ROADMAP_STATUS_COMPLETE = 'BOOK_ROADMAP_STATUS_COMPLETE',
    BOOK_ROADMAP_STATUS_SKIPPED = 'BOOK_ROADMAP_STATUS_SKIPPED',
}

export type GetBookProgressRequest = {
    studentId?: string;
    academicMonth?: string;
};

export type GetBookProgressResponse = {
    books?: BookProgress[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
};

export type GetBookProgressSummaryRequest = {
    studentId?: string;
    academicMonth?: string;
};

export type GetBookProgressSummaryResponse = {
    student?: StudentInfo;
    attendance?: AttendanceSummary;
    supplements?: SupplementGroup[];
    teacherNotesOverall?: TeacherNotes;
    teacherNotesByBook?: TeacherNotesByBook[];
    monthlyStats?: string[];
    bookProgressTeaser?: BookProgressTeaser;
};

export type BookProgressTeaser = {
    activeBookCount?: number;
    currentBookName?: string;
    completedBookCount?: number;
};

export type BookProgressTeaserV1 = {
    activeBookCount?: number;
    currentBookName?: string;
    completedBookCount?: number;
};

export type GetBookProgressReleasedRequest = {
    studentId?: string;
    academicMonth?: string;
};

export type GetBookProgressReleasedEnvelopeResponse = {
    code?: number;
    message?: string;
    data?: BookProgressReleasedData;
};

export type BookProgressReleasedData = {
    released?: boolean;
};

export type GetBookProgressV1EnvelopeResponse = {
    code?: number;
    message?: string;
    data?: BookProgressV1Data;
};

export type BookProgressV1Data = {
    books?: BookProgressV1[];
};

export type BookProgressV1 = {
    id?: number;
    name?: string;
    levelLabel?: string;
    state?: string;
    totalPages?: number;
    completedPages?: number;
    units?: UnitProgressV1[];
};

export type UnitProgressV1 = {
    id?: number;
    number?: string;
    name?: string;
    totalWorksheets?: number;
    completedWorksheets?: number;
    subunits?: SubunitProgressV1[];
};

export type SubunitProgressV1 = {
    id?: number;
    number?: string;
    name?: string;
    totalWorksheets?: number;
    completedWorksheets?: number;
    finished?: number;
    skipped?: number;
    notStarted?: number;
    unitTest?: UnitTestProgressV1;
};

export type UnitTestProgressV1 = {
    score?: number | null;
    maxScore?: number | null;
    percentage?: number | null;
};

export type GetBookProgressSummaryV1EnvelopeResponse = {
    code?: number;
    message?: string;
    data?: BookProgressSummaryV1Data;
};

export type BookProgressSummaryV1Data = {
    supplements?: SupplementV1[];
    teacherNotes?: TeacherNotesV1;
    bookProgressTeaser?: BookProgressTeaserV1;
    attendance?: AttendanceSummaryV1;
    monthlyStats?: string[];
};

export type SupplementV1 = {
    bookId?: number;
    bookName?: string;
    unitName?: string;
    subunitName?: string;
    worksheetCount?: number;
};

export type TeacherNotesV1 = {
    overall?: TeacherNoteOverallV1;
    byBook?: TeacherNoteByBookV1[];
};

export type TeacherNoteOverallV1 = {
    positive?: string;
    overall?: string;
    growth?: string;
    teacher?: string;
};

export type TeacherNoteByBookV1 = {
    bookId?: number;
    bookName?: string;
    notes?: string;
};

export type StudentInfo = {
    garageStudentId?: string;
    name?: string;
    nickname?: string;
    cohort?: string;
    levelLabel?: string;
    activeBooks?: ActiveBook[];
};

export type ActiveBook = {
    bookId?: number;
    bookName?: string;
    levelLabel?: string;
};

export type BookProgress = {
    bookId?: number;
    bookName?: string;
    levelLabel?: string;
    totalPages?: number;
    completedPages?: number;
    units?: UnitProgress[];
};

export type SubunitProgress = {
    subunitId?: number;
    subunitName?: string;
    totalWorksheets?: number;
    completedWorksheets?: number;
    isCheckpoint?: boolean;
    subunitOrder?: number;
    finishedWorksheets?: number;
    skippedWorksheets?: number;
    notStartedWorksheets?: number;
    writtenScore?: number;
    totalScore?: number;
    subunitNumber?: number;
};

export type UnitProgress = {
    unitId?: number;
    unitNumber?: number;
    unitName?: string;
    subunits?: SubunitProgress[];
};

export type WorksheetProgress = {
    worksheetId?: number;
    worksheetName?: string;
    status?: BookRoadmapStatus;
    writtenScore?: number;
    totalScore?: number;
    subunitId?: number;
    subunitName?: string;
    isCheckpoint?: boolean;
    subunitNumber?: number;
};

export type AttendanceSummary = {
    totalSessions?: number;
    attended?: number;
    absent?: number;
};

export type AttendanceSummaryV1 = {
    totalSessions?: number;
    attended?: number;
    absent?: number;
};

export type SupplementGroup = {
    bookId?: number;
    bookName?: string;
    units?: UnitSupplement[];
};

export type UnitSupplement = {
    unitId?: number;
    unitName?: string;
    subunits?: SubunitSupplement[];
};

export type SubunitSupplement = {
    subunitId?: number;
    subunitName?: string;
    worksheetCount?: number;
};

export type TeacherNotes = {
    positive?: string;
    overall?: string;
    growth?: string;
    teacherName?: string;
    teacherAvatarUrl?: string;
};

export type TeacherNotesByBook = {
    bookId?: number;
    bookName?: string;
    notes?: TeacherNotes;
};

export type MathStudentTrackerMonthlyItem = {
    studentProfile?: EdukitaPaulaBackendGaragecacheProfiles.GarageStudentProfile;
    parentProfile?: EdukitaPaulaBackendGaragecacheProfiles.GarageParentProfile;
    subscriptionStatus?: string;
    academicMonth?: string;
    mathTracker?: MathTracker;
};

export type MathTracker = {
    id?: string;
    mathStudentTrackerId?: string;
    academicYear?: number;
    bookId?: string;
    bookName?: string;
    levelLabel?: string;
    intendedAttendance?: number;
    actualAttendance?: number;
    attendanceNeedAttention?: boolean;
    attendanceSessions?: EdukitaPaulaBackendV3Common.AttendanceSession[];
    flagToParents?: boolean;
    tenureMonth?: number;
    teacherProfiles?: EdukitaPaulaBackendGaragecacheProfiles.GarageTeacherProfile[];
    partnerInfo?: EdukitaPaulaBackendGaragecacheEntities.GaragePartnerInfo;
    worksheetsDone?: number;
    worksheetsTotal?: number;
    pagesDone?: number;
    pagesTotal?: number;
    scorePercentage?: number;
};

export type GetMathStudentTrackersRequest = {
    academicMonth?: string;
    garageStudentId?: number;
    garageStudentName?: string;
    garageParentName?: string;
    bookIds?: number[];
    garageTeacherIds?: number[];
    subscriptionStatus?: string;
    attendanceNeedAttention?: string;
    flagToParentNeedAttention?: string;
    page?: number;
    pageSize?: number;
    garagePartnerId?: number;
    tenureMonth?: number;
};

export type GetMathStudentTrackersResponse = {
    items?: MathStudentTrackerMonthlyItem[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
};

export type GetMathStudentTrackerFiltersResponse = {
    filters?: EdukitaPaulaBackendCommonFilter.FilterDefinition[];
};

export class BookTrackerService {
    static GetBookProgress(
        this: void,
        req: GetBookProgressRequest,
        initReq?: fm.InitReq
    ): Promise<GetBookProgressResponse> {
        return fm.fetchRequest<GetBookProgressResponse>(
            `/v3/math/students/${
                req.studentId
            }/book-progress?${fm.renderURLSearchParams(req, ['studentId'])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetBookProgressReleased(
        this: void,
        req: GetBookProgressReleasedRequest,
        initReq?: fm.InitReq
    ): Promise<GetBookProgressReleasedEnvelopeResponse> {
        return fm.fetchRequest<GetBookProgressReleasedEnvelopeResponse>(
            `/api/v1/learning/math/book-progress/released?${fm.renderURLSearchParams(
                req,
                []
            )}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetBookProgressV1(
        this: void,
        req: GetBookProgressRequest,
        initReq?: fm.InitReq
    ): Promise<GetBookProgressV1EnvelopeResponse> {
        return fm.fetchRequest<GetBookProgressV1EnvelopeResponse>(
            `/api/v1/learning/math/book-progress?${fm.renderURLSearchParams(
                req,
                []
            )}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetBookProgressSummary(
        this: void,
        req: GetBookProgressSummaryRequest,
        initReq?: fm.InitReq
    ): Promise<GetBookProgressSummaryResponse> {
        return fm.fetchRequest<GetBookProgressSummaryResponse>(
            `/v3/math/students/${
                req.studentId
            }/book-progress/summary?${fm.renderURLSearchParams(req, ['studentId'])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetBookProgressSummaryV1(
        this: void,
        req: GetBookProgressSummaryRequest,
        initReq?: fm.InitReq
    ): Promise<GetBookProgressSummaryV1EnvelopeResponse> {
        return fm.fetchRequest<GetBookProgressSummaryV1EnvelopeResponse>(
            `/api/v1/learning/math/book-progress/summary?${fm.renderURLSearchParams(
                req,
                []
            )}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetMathStudentTrackers(
        this: void,
        req: GetMathStudentTrackersRequest,
        initReq?: fm.InitReq
    ): Promise<GetMathStudentTrackersResponse> {
        return fm.fetchRequest<GetMathStudentTrackersResponse>(
            `/v3/math/student-trackers/monthly?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetMathStudentTrackerFilters(
        this: void,
        req: GoogleProtobufEmpty.Empty,
        initReq?: fm.InitReq
    ): Promise<GetMathStudentTrackerFiltersResponse> {
        return fm.fetchRequest<GetMathStudentTrackerFiltersResponse>(
            `/v3/math/student-trackers/filters?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
}
